import { jsxs as s, jsx as o } from "react/jsx-runtime";
import { Button as n } from "../../forms/button/index.js";
import '../../../assets/solutions.css';const d = "_solution_6rtya_1", p = "_button__primary_6rtya_55", i = {
  solution: d,
  "solution--info": "_solution--info_6rtya_6",
  "solution--info--subtitle": "_solution--info--subtitle_6rtya_10",
  "solution--info--title": "_solution--info--title_6rtya_13",
  "solution--info--paragraph": "_solution--info--paragraph_6rtya_16",
  "solution--info--actions": "_solution--info--actions_6rtya_20",
  "solution--info--actions--button__advisor": "_solution--info--actions--button__advisor_6rtya_26",
  "solution--figure": "_solution--figure_6rtya_30",
  button__primary: p
};
function h({
  plansButtonContent: a = "Ver planes",
  onClickPlansButton: t = () => {
  },
  advisorButtonContent: e = "Contacta a nuestro equipo",
  advisorButtonUpperContent: l = "¿Necesitas un volumen mayor?",
  onClickAdvisorButton: r = () => {
  },
  content: u = "Evaluación de terrenos para proyectos inmobiliarios. Ofrecemos soluciones corporativas para cualquier volumen de demanda. Tenemos paquetes diseñados para grandes empresas del sector, garantizando un servicio integral adaptable a sus requisitos más exigentes.",
  subtitle: c = "Soluciones adaptadas a tus necesidades",
  title: m = "Tu mejor aliado en las etapas iniciales",
  figureContent: _ = "Inserte imagen aqui"
}) {
  return /* @__PURE__ */ s("section", { className: `${i.solution}`, children: [
    /* @__PURE__ */ s("article", { className: `${i["solution--info"]}`, children: [
      /* @__PURE__ */ o(
        "h5",
        {
          className: `${i["solution--info--subtitle"]} b-mb-4 md:b-mb-2`,
          children: c
        }
      ),
      /* @__PURE__ */ o("h2", { className: `${i["solution--info--title"]} b-mb-6 md:b-mb-4`, children: m }),
      /* @__PURE__ */ o("p", { className: `${i["solution--info--paragraph"]} b-mb-6`, children: u }),
      /* @__PURE__ */ s("div", { className: `${i["solution--info--actions"]}`, children: [
        /* @__PURE__ */ o(n, { className: "md:b-max-w-52", onClick: t, children: a }),
        /* @__PURE__ */ s("span", { className: "b-text-center b-text-sm", children: [
          /* @__PURE__ */ o("span", { children: l }),
          /* @__PURE__ */ o("hr", { className: "b-m-0" }),
          /* @__PURE__ */ o(
            n,
            {
              className: `${i["solution--info--actions--button__advisor"]}`,
              onClick: r,
              styleType: "link",
              children: e
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ o("figure", { className: `${i["solution--figure"]}`, children: _ })
  ] });
}
export {
  h as default
};
